
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiLguJ7guJrguITguLPguJfguLXguYjguYTguKHguYjguYDguKvguKHguLLguLDguKrguKEifQ==!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiLguJ7guJrguITguLPguJfguLXguYjguYTguKHguYjguYDguKvguKHguLLguLDguKrguKEifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJLYXRhIHRpZGFrIHBhbnRhcyJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJLYXRhIHRpZGFrIHBhbnRhcyJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiLguJ7guJrguITguLPguJfguLXguYjguYTguKHguYjguYDguKvguKHguLLguLDguKrguKEifQ==!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiLguJ7guJrguITguLPguJfguLXguYjguYTguKHguYjguYDguKvguKHguLLguLDguKrguKEifQ==!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJLYXRhIHRpZGFrIHBhbnRhcyJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJLYXRhIHRpZGFrIHBhbnRhcyJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJJbmFwcHJvcHJpYXRlIHdvcmQifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJbw4/guIHguLXguYnEg8SDxIPGpcalxZnDtsO2w7bGpcWZw6zDrMOsxIPEg8SD4bmv4bq94bq94bq9IMW1w7bDtsO2xZnGjF0ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJJbmFwcHJvcHJpYXRlIHdvcmQiOiJbw4/guIHguLXguYnEg8SDxIPGpcalxZnDtsO2w7bGpcWZw6zDrMOsxIPEg8SD4bmv4bq94bq94bq9IMW1w7bDtsO2xZnGjF0ifQ==!"
        )
      )
      });
  
      export { translations as default };
    